import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DistrictService {
  constructor(private ws: PostmethodService) { }

  createDistrict(request: any) {
    return this.ws.wsPost(request, environment.baseUrl + "masters/district");
  }

  updateDistrict(request: any, id: any) {
    return this.ws.wsPut(request, environment.baseUrl + "masters/district", id);
  }

  getDistrict() {
    return this.ws.wsGet(environment.baseUrl + "masters/district");
  }

  getCountry() {
    return this.ws.wsGet(environment.baseUrl + "masters/countries");
  }

  getZoneByCountry(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "/common/get-zones-by-country", id);
  }

  getStateByZone(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "common/get-states-by-zone", id);
  }

  getRegionByState(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "common/get-regions-by-state", id);
  }
}
